import React from "react";
import TablePagination from "./TablePagination";

export default function SingleTripsTable({
  themeColor,
  singleSearch,
  setSingleSearch,
  handleSort,
  handleRowClick,
  expandedRows,
  sortConfig,
  singleTrips,
  pagination,
  onPageChange,
}) {
  return (
    <div
      className="w-full flex flex-col rounded-lg h-96 bg-white p-2"
      style={{
        boxShadow:
          "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.06), 0 -4px 6px -1px rgba(0,0,0,0.1), 0 -2px 4px -2px rgba(0,0,0,0.06)",
      }}
    >
      {/* Header section */}
      <div className="flex justify-between items-center w-full bg-transparent p-2">
        <div
          className="text-xl flex items-center justify-center font-medium"
          style={{ color: themeColor }}
        >
          Single Trips
        </div>
        <div className="relative flex items-center">
          <input
            type="text"
            placeholder="Search"
            value={singleSearch}
            onChange={(e) => setSingleSearch(e.target.value)}
            style={{ paddingTop: "0.44rem", paddingBottom: "0.44rem" }}
            className="w-full pl-4 pr-10 text-gray-800 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 placeholder-gray-400 placeholder-opacity-100 font-light text-sm"
          />
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <svg
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              ></path>
            </svg>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-y-auto px-2 scrollbar">
        <table className="table-auto border-collapse w-full h-full">
          <thead>
            <tr className="bg-white border-b">
              <th
                className="cursor-pointer text-left font-light"
                style={{ color: "#6E6C71" }}
                onClick={() => handleSort("name")}
              >
                Name{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1"
                >
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === "name" &&
                      sortConfig.direction === "asc"
                        ? "#745D96"
                        : "#9C9C9C"
                    }
                  />
                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === "name" &&
                      sortConfig.direction === "desc"
                        ? "#745D96"
                        : "#9C9C9C"
                    }
                  />
                </svg>
              </th>
              <th
                className="cursor-pointer text-left font-light"
                style={{ color: "#6E6C71" }}
                onClick={() => handleSort("total_trips")}
              >
                Trips{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1"
                >
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === "total_trips" &&
                      sortConfig.direction === "asc"
                        ? "#745D96"
                        : "#9C9C9C"
                    }
                  />
                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === "total_trips" &&
                      sortConfig.direction === "desc"
                        ? "#745D96"
                        : "#9C9C9C"
                    }
                  />
                </svg>
              </th>
              <th
                className="cursor-pointer text-left font-light"
                style={{ color: "#6E6C71" }}
                onClick={() => handleSort("total_cost")}
              >
                Costs{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1"
                >
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === "total_cost" &&
                      sortConfig.direction === "asc"
                        ? "#745D96"
                        : "#9C9C9C"
                    }
                  />
                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === "total_cost" &&
                      sortConfig.direction === "desc"
                        ? "#745D96"
                        : "#9C9C9C"
                    }
                  />
                </svg>
              </th>
            </tr>
          </thead>
          <tbody>
            {singleTrips.length === 0 ? (
              <tr>
                <td
                  className="flex items-center justify-center h-full p-5 text-center"
                  style={{ color: themeColor }}
                >
                  No Information available for the selected period.
                </td>
              </tr>
            ) : (
              singleTrips.map((item) => (
                <React.Fragment key={item.name}>
                  <tr>
                    <td className="font-light">{item.name}</td>
                    <td className="font-light">{item.total_trips}</td>
                    <td className="font-light">
                      R{item.total_cost.toFixed(2)}
                    </td>
                    <td className="p-2 space-x-1 flex items-end justify-end">
                      <button
                        onClick={() => handleRowClick(item.name)}
                        className="p-2 rounded hover:bg-gray-200"
                        style={{ backgroundColor: "#9B999E" }}
                      >
                        {expandedRows.includes(item.name) ? (
                          <svg
                            width="20"
                            height="10"
                            viewBox="0 0 20 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19 1C16.6 3.667 13.6 5 10 5C6.4 5 3.4 3.667 1 1M1 7.00001L3.5 3.20001M18.9998 6.97601L16.5078 3.20001M7 9L7.5 5M13 9L12.5 5"
                              stroke="white"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="20"
                            height="14"
                            viewBox="0 0 20 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 7C8 7.53043 8.21071 8.03914 8.58579 8.41421C8.96086 8.78929 9.46957 9 10 9C10.5304 9 11.0391 8.78929 11.4142 8.41421C11.7893 8.03914 12 7.53043 12 7C12 6.46957 11.7893 5.96086 11.4142 5.58579C11.0391 5.21071 10.5304 5 10 5C9.46957 5 8.96086 5.21071 8.58579 5.58579C8.21071 5.96086 8 6.46957 8 7Z"
                              stroke="white"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M19 7C16.6 11 13.6 13 10 13C6.4 13 3.4 11 1 7C3.4 3 6.4 1 10 1C13.6 1 16.6 3 19 7Z"
                              stroke="white"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </button>
                    </td>
                  </tr>
                  {expandedRows.includes(item.name) && (
                    <>
                      <tr className="border-t-2">
                        <td className="font-light" style={{ color: "#6E6C71" }}>
                          Date{" "}
                        </td>
                        <td className="font-light" style={{ color: "#6E6C71" }}>
                          Costs
                        </td>
                        <td colSpan={2}></td>
                      </tr>

                      {item.trips.map((trip, i) => (
                        <tr key={i}>
                          <td className="font-light">{trip.date}</td>
                          <td className="font-light">
                            R{trip.cost.toFixed(2)}
                          </td>
                          <td colSpan={2}></td>
                        </tr>
                      ))}
                    </>
                  )}
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>

      <TablePagination pagination={pagination} onPageChange={onPageChange} />
    </div>
  );
}
